module.exports = __webpack_public_path__ + "Roboto-Bold.c0f1e4a4fdfb8048c72e.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/fmancia/repo/gitlab/frontend-snj/~/materialize-css/dist/fonts/roboto/Roboto-Bold.woff2
// module id = ../../../../materialize-css/dist/fonts/roboto/Roboto-Bold.woff2
// module chunks = 2